import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert, Accordion, Badge } from 'react-bootstrap';
import axios from 'axios';

const AnamneseViewTab = ({ pacienteId }) => {
    const [anamneses, setAnamneses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAnamneses = async () => {
            if (!pacienteId) return;
            setIsLoading(true);
            try {
                const response = await axios.get(`/api/anamneses?paciente_id=${pacienteId}`);
                setAnamneses(response.data.anamneses || []);
            } catch (error) {
                console.error("Erro ao buscar anamneses:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchAnamneses();
    }, [pacienteId]);

    if (isLoading) return <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div>;

    if (anamneses.length === 0) {
        return (
            <Alert variant="light" className="border">
                <i className="bi bi-info-circle me-2"></i>
                O paciente ainda não preencheu nenhuma ficha de anamnese no tablet.
            </Alert>
        );
    }

    return (
        <div className="anamnese-view-container" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
            <Accordion defaultActiveKey="0">
                {anamneses.map((anamnese, idx) => (
                    <Accordion.Item eventKey={String(idx)} key={anamnese.id}>
                        <Accordion.Header>
                            <div className="d-flex justify-content-between w-100 me-3 align-items-center">
                                <span>Ficha: <strong className="text-primary">{anamnese.tipo_ficha}</strong></span>
                                <Badge bg="light" text="dark" className="border">
                                    {new Date(anamnese.created_at).toLocaleDateString('pt-BR')}
                                </Badge>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Table striped hover mb={0} size="sm" className="align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: '60%' }}>Pergunta</th>
                                        <th>Resposta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {anamnese.respostas.map(resp => (
                                        <tr key={resp.id}>
                                            <td className="ps-3 py-2">{resp.pergunta?.pergunta}</td>
                                            <td className="fw-bold text-dark">{resp.resposta}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </div>
    );
};

export default AnamneseViewTab;
